/**
 * Unions API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GeoPoint } from './geoPoint';


export interface CityWithGeoViewDto { 
    /**
     * Id города
     */
    cityId: number;
    /**
     * Наименование города
     */
    city: string;
    /**
     * Наименование области (региона)
     */
    regionName?: string;
    geoPoint?: GeoPoint;
}

